import { useQuery, useQueryClient } from "@tanstack/react-query";
import type { Withdrawal } from "../types";
import { fetchAllWithdrawals } from "../app/api/withdrawals";

export function useWithdrawals() {
  return useQuery<Withdrawal[], Error>({
    queryKey: ["withdrawals"],
    queryFn: fetchAllWithdrawals,
    staleTime: 1000,
    retry: 1,
  });
}

export function useWithdrawal(id: string) {
  const queryClient = useQueryClient();

  const cached = queryClient.getQueryData<Withdrawal[]>(["withdrawals"]);
  const initial = cached?.find((u) => u.id === id) ?? null;

  return useQuery<Withdrawal | null, Error>({
    queryKey: ["withdrawals", id],
    enabled: !initial,
    initialData: initial,
    queryFn: async () => {
      const withdrawals = await fetchAllWithdrawals();
      const u = withdrawals.find((u) => u.id === id);
      if (!u) throw new Error("withdrawals not found");
      return u;
    },
  });
}
